import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RecentQuiz from "./RecentQuiz";
import PracticeQuizFlow from "../practice/PracticeQuizFlow";
import LearnFlow from "../practice/LearnFlow";
import DuelFlow from "../duel/DuelFlow";
import TournamentHub, { TournamentLobby } from "../tournament/TournamentHub";
import GameHub from "./GameHub";
import ViewQuizAnswers from "../class-quiz/ViewQuizAnswers";

const StudentQuizRouter = () => {
  return (
    <Routes>
      <Route index element={<RecentQuiz />} />
      <Route path="view/:id" element={<ViewQuizAnswers />} />
      <Route path="play" element={<GameHub />}>
        <Route path="practice/quiz" element={<PracticeQuizFlow />} />
        <Route path="practice/learn" element={<LearnFlow />} />
        <Route path="duel" element={<DuelFlow />} />
        <Route path="tournament" element={<TournamentHub />} />
        <Route path="tournament/:id" element={<TournamentLobby />} />
      </Route>
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default StudentQuizRouter;
